import { FC, useCallback, useMemo, useState } from "react";
import { Tooltip } from "reactstrap";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

const GUIDELINES_URL =
  "https://www.trustfinance.com/legal/for-reviewers/recommendations-for-reviewers";

const WidgetTemplate11: FC<IWidgetTemplate> = ({ company, score, theme }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const isDark = theme === "dark";
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 11 as const }),
    [companyId],
  );

  const companyUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=starter`,
    [companyId],
  );

  const toggle = useCallback(() => setTooltipOpen((open) => !open), []);

  return (
    <div className="overflow-hidden d-flex justify-content-center">
      <a
        className="text-decoration-none"
        style={{ color: isDark ? "white" : "unset" }}
        href={companyUrl}
        target="_blank"
        rel="noreferrer noopener"
        id="Tooltip-widget11"
        onClick={() => ReachClick(payload)}
      >
        <div className="review-score">
          <div>
            Check out our <b>{score?.totalReview} reviews</b>
          </div>
          <div className="fs-16 d-flex align-items-center p-2 fw-bold">
            <StarRateNewTrustScore value={score?.score} size={24} />
          </div>
          <div className="d-flex align-items-center txt p-2">
            <img src={LOGO_MARK} alt="TrustFinance" width={24} height={24} />
            <span className="fs-16">TrustFinance</span>
          </div>
        </div>
      </a>
      <Tooltip
        placement="bottom"
        isOpen={tooltipOpen}
        target="Tooltip-widget11"
        autohide={false}
        toggle={toggle}
        style={{ backgroundColor: isDark ? "white" : "black" }}
        hideArrow
      >
        <div style={{ color: isDark ? "black" : "white" }}>
          Helping each other make better choices.{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href={GUIDELINES_URL}
          >
            Read and write reviews
          </a>
        </div>
      </Tooltip>
    </div>
  );
};

export default WidgetTemplate11;
